import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import useAppVersion from '@src/model/config/hooks/useAppVersion';

interface AppVersionProps {
    className?: string;
}

const AppVersion: React.FC<AppVersionProps> = props => {
    const { className = '' } = props;
    const { version, branch, commitHash } = useAppVersion();
    const dataAttr = JSON.stringify({ version, branch, commitHash });

    return (
        <Text className={cn('', className)} data-app-version={dataAttr}>
            {branch}-{commitHash}
        </Text>
    );
};

export default AppVersion;
